import { ProductSaleFlow } from "@expert/sales-tools";
import { Flex, Text, UnstyledButton } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { ErrorBoundary } from "react-error-boundary";

import { RenderError } from "@/shared-utils";

interface ProductSaleFlowPanelProps {
    onBack?: () => void;
}

export function ProductSaleFlowPanel({ onBack }: ProductSaleFlowPanelProps) {
    return (
        <Flex pos={"absolute"} inset={0} bg="dark.7" direction="column">
            {onBack && (
                <Flex px="sm" py="xs">
                    <UnstyledButton onClick={onBack}>
                        <Flex align="center" gap={4}>
                            <IconArrowLeft size={14} color="var(--mantine-color-dark-1)" />
                            <Text fz="sm" c="dark.1">
                                Back to offers
                            </Text>
                        </Flex>
                    </UnstyledButton>
                </Flex>
            )}
            <Flex flex={1} pos="relative" style={{ overflow: "hidden" }}>
                <ErrorBoundary fallback={<RenderError />}>
                    <ProductSaleFlow />
                </ErrorBoundary>
            </Flex>
        </Flex>
    );
}
